/** Enrollment screen paths, in flow order. Routed as `/${basePath}${route}`. */
export enum EnrollRoute {
  PlanSelection = "/select-plan",
  ZipUtility = "/zip-utility",
  ZipUtilitySearch = "/zip-utility/search",
  ZipUtilitySplit = "/zip-utility/split",
  ZipUtilityIneligible = "/zip-utility/ineligible",
  ConfirmRate = "/rate",
  ConfirmAddress = "/service-address/confirm",
  PickAddressIntro = "/service-address/search",
  ManualServiceAddress = "/service-address/enter-address",
  ManualUtilityAccountNumber = "/service-address/enter-account-number",
  VerifyIdentity = "/verify-identity",
  CreditCheck = "/credit-check",
  PaymentSetup = "/setup-payment",
  VerifyAndEnroll = "/confirm-and-enroll",
}
